module.exports = __webpack_public_path__ + "./images/unassigned.e1c904.svg";